
import { FocusState, StateConfig, Language } from './types';

export const TRANSLATIONS = {
  [Language.EN]: {
    landing: {
      title: "GATEWAY PROCESS",
      status: "NEURAL SYNC STANDBY",
      start: "START SESSION",
      headphones: "Headphones Required",
      docs: "DECLASSIFIED DOCUMENTS",
      source: "OFFICIAL CIA SOURCE",
      equipment: "EQUIPMENT",
      headerTitle: "GATEWAY PROTOCOL",
      headerStatus: "STATUS"
    },
    tabs: {
      tools: "1. PREPARATION",
      session: "2. EXPLORE"
    },
    tools: {
      box: "1. BOX",
      shield: "2. SHIELD",
      vol: "VOL",
      box_title: "Energy Conversion Box",
      box_subtitle: "Enclose your physical worries. Watch them disintegrate into neural dust.",
      box_placeholder: "Type your worries here...",
      box_button: "RELEASE INTO VOID",
      box_mind_cleared: "Mind Cleared",
      box_proceed: "Proceed to Resonant Tuning",
      box_vacuum: "VACUUM_READY",
      box_containment: "Containment Field Active",
      box_node: "Subconscious Purge Node",
      shield_title: "RESONANT ENERGY BALLOON (REBAL)",
      shield_subtitle: "Activate your high-frequency protective sphere to shield your awareness.",
      shield_button: "INITIATE RESONANT SHIELD",
      shield_active: "REBAL ACTIVE",
      shield_proceed: "PROCEED TO EXPLORATION",
      shield_node: "Protective Awareness Shield",
      shield_standby: "Standby",
      shield_awaiting: "Awaiting Initialization",
      shield_charging: "CHARGING FREQUENCY",
      shield_stabilized: "SHIELD STABILIZED"
    },
    monitor: {
      title: "NEURAL STATE MONITOR",
      left: "LEFT CHANNEL",
      right: "RIGHT CHANNEL",
      diff: "BINAURAL DIFF",
      activation: "NEURAL FOCUS ACTIVATION",
      locked: "Locked",
      sync: "PHASE SYNC LOCKED",
      instructions: "INSTRUCTIONS"
    },
    timer: {
      sync: "NEURAL SYNC",
      headphones: "Headphones Required",
      terminate: "TERMINATE SYNC",
      autopilot_active: "AUTOPILOT ACTIVE",
      autopilot_activate: "ACTIVATE AUTOPILOT",
      auto_sequence: "AUTO SEQUENCE: F10 → F21 Active"
    },
    obe: {
      title: "OBE PROTOCOL ALPHA",
      subtitle: "Vibrational Separation",
      resonanceActive: "Resonance Active",
      instruction: "Select vibrational resonance duration to trigger separation protocol.",
      initiate: "INITIATE RESONANCE",
      terminate: "TERMINATE SYNC",
      intro: "If Focus Levels are the map, the OBE is the act of deploying personnel.",
      vibrationalTitle: "The Vibrational State",
      vibrationalContent: "The onset signal of separation. Ride the wave rather than fear it.",
      protocols: [
        { name: "Protocol 1: The Roll-Out", description: "Mentally roll your consciousness over without tensing muscles." },
        { name: "Protocol 2: The Lift-Out", description: "Imagine your energy body as a helium balloon and float up." },
        { name: "Protocol 3: Teleportation", description: "Shift focus to a distant location instantly." }
      ],
      closing: "The Silver Cord is your infinite, indestructible tether."
    },
    briefing: {
      title: "Intelligence Briefing",
      sensations: "SENSATIONS",
      methodology: "METHODOLOGY"
    }
  },
  [Language.IT]: {
    landing: {
      title: "PROCESSO GATEWAY",
      status: "SYNC NEURALE IN STANDBY",
      start: "INIZIA SESSIONE",
      headphones: "Cuffie Richieste",
      docs: "DOCUMENTI DECLASSIFICATI",
      source: "FONTE UFFICIALE CIA",
      equipment: "EQUIPAGGIAMENTO",
      headerTitle: "PROTOCOLLO GATEWAY",
      headerStatus: "STATO"
    },
    tabs: {
      tools: "1. PREPARAZIONE",
      session: "2. ESPLORA"
    },
    tools: {
      box: "1. SCATOLA",
      shield: "2. SCUDO",
      vol: "VOL",
      box_title: "Scatola di Conversione Energetica",
      box_subtitle: "Rinchiudi le tue preoccupazioni fisiche. Guardale disintegrarsi in polvere neurale.",
      box_placeholder: "Scrivi qui le tue preoccupazioni...",
      box_button: "RILASCIA NEL VUOTO",
      box_mind_cleared: "Mente Liberata",
      box_proceed: "Procedi all'Accordatura Risonante",
      box_vacuum: "VUOTO_PRONTO",
      box_containment: "Campo di Contenimento Attivo",
      box_node: "Nodo di Epurazione Subconscia",
      shield_title: "PALLONE DI ENERGIA RISONANTE (REBAL)",
      shield_subtitle: "Attiva la tua sfera protettiva ad alta frequenza per schermare la tua consapevolezza.",
      shield_button: "INIZIA SCUDO RISONANTE",
      shield_active: "REBAL ATTIVO",
      shield_proceed: "PROCEDI ALL'ESPLORAZIONE",
      shield_node: "Scudo di Consapevolezza Protettiva",
      shield_standby: "Standby",
      shield_awaiting: "In attesa di inizializzazione",
      shield_charging: "CARICAMENTO FREQUENZA",
      shield_stabilized: "SCUDO STABILIZZATO"
    },
    monitor: {
      title: "MONITOR STATO NEURALE",
      left: "CANALE SINISTRO",
      right: "CANALE DESTRO",
      diff: "DIFF. BINAURALE",
      activation: "ATTIVAZIONE FOCUS NEURALE",
      locked: "Bloccato",
      sync: "SYNC DI FASE BLOCCATO",
      instructions: "ISTRUZIONI"
    },
    timer: {
      sync: "SYNC NEURALE",
      headphones: "Cuffie Richieste",
      terminate: "TERMINA SYNC",
      autopilot_active: "AUTOPILOTA ATTIVO",
      autopilot_activate: "ATTIVA AUTOPILOTA",
      auto_sequence: "SEQUENZA AUTO: F10 → F21 Attiva"
    },
    obe: {
      title: "PROTOCOLLO OBE ALPHA",
      subtitle: "Separazione Vibrazionale",
      resonanceActive: "Risonanza Attiva",
      instruction: "Seleziona la durata della risonanza vibrazionale per attivare il protocollo di separazione.",
      initiate: "INIZIA RISONANZA",
      terminate: "TERMINA SYNC",
      intro: "Se i Livelli di Focus sono la mappa, l'OBE è l'atto di dispiegare il personale.",
      vibrationalTitle: "Lo Stato Vibrazionale",
      vibrationalContent: "Il segnale di inizio della separazione. Cavalca l'onda invece di temerla.",
      protocols: [
        { name: "Protocollo 1: Il Roll-Out", description: "Fai rotolare mentalmente la tua coscienza senza tendere i muscoli." },
        { name: "Protocollo 2: Il Lift-Out", description: "Immagina il tuo corpo energetico come un palloncino all'elio e fluttua verso l'alto." },
        { name: "Protocollo 3: Teletrasporto", description: "Sposta istantaneamente il focus su una posizione distante." }
      ],
      closing: "Il Cordone d'Argento è il tuo legame infinito e indistruttibile."
    },
    briefing: {
      title: "Briefing di Intelligence",
      sensations: "SENSAZIONI",
      methodology: "METODOLOGIA"
    }
  },
  [Language.DE]: {
    landing: {
      title: "GATEWAY-PROZESS",
      status: "NEURALER SYNC STANDBY",
      start: "SITZUNG STARTEN",
      headphones: "Kopfhörer erforderlich",
      docs: "GEHEIME DOKUMENTE",
      source: "OFFIZIELLE CIA-QUELLE",
      equipment: "AUSRÜSTUNG",
      headerTitle: "GATEWAY-PROTOKOLL",
      headerStatus: "STATUS"
    },
    tabs: {
      tools: "1. VORBEREITUNG",
      session: "2. ERKUNDEN"
    },
    tools: {
      box: "1. BOX",
      shield: "2. SCHILD",
      vol: "VOL",
      box_title: "Energie-Umwandlungs-Box",
      box_subtitle: "Schließe deine physischen Sorgen ein. Sieh zu, wie sie zu neuralem Staub zerfallen.",
      box_placeholder: "Schreibe deine Sorgen hier...",
      box_button: "IN DIE LEERE ENTLASSEN",
      box_mind_cleared: "Geist geklärt",
      box_proceed: "Weiter zur resonanten Abstimmung",
      box_vacuum: "VAKUUM_BEREIT",
      box_containment: "Eindämmungsfeld aktiv",
      box_node: "Unterbewusster Reinigungsknoten",
      shield_title: "RESONANZ-ENERGIE-BALLON (REBAL)",
      shield_subtitle: "Aktiviere deine hochfrequente Schutzsphäre, um dein Bewusstsein abzuschirmen.",
      shield_button: "RESONANZ-SCHILD INITIALISIEREN",
      shield_active: "REBAL AKTIV",
      shield_proceed: "WEITER ZUR ERKUNDUNG",
      shield_node: "Schutz-Bewusstseins-Schild",
      shield_standby: "Standby",
      shield_awaiting: "Warten auf Initialisierung",
      shield_charging: "FREQUENZ WIRD GELADEN",
      shield_stabilized: "SCHILD STABILISIERT"
    },
    monitor: {
      title: "NEURALER ZUSTANDS-MONITOR",
      left: "LINKER KANAL",
      right: "RECHTER KANAL",
      diff: "BINAURALE DIFF",
      activation: "NEURALE FOKUS-AKTIVIERUNG",
      locked: "Gesperrt",
      sync: "PHASEN-SYNC GESPERRT",
      instructions: "ANWEISUNGEN"
    },
    timer: {
      sync: "NEURALER SYNC",
      headphones: "Kopfhörer erforderlich",
      terminate: "SYNC BEENDEN",
      autopilot_active: "AUTOPILOT AKTIV",
      autopilot_activate: "AUTOPILOT AKTIVIEREN",
      auto_sequence: "AUTO-SEQUENZ: F10 → F21 Aktiv"
    },
    obe: {
      title: "OBE-PROTOKOLL ALPHA",
      subtitle: "Vibrationstrennung",
      resonanceActive: "Resonanz aktiv",
      instruction: "Wähle die Dauer der Vibrationsresonanz, um das Trennungsprotokoll auszulösen.",
      initiate: "RESONANZ STARTEN",
      terminate: "SYNC BEENDEN",
      intro: "Wenn Fokus-Level die Karte sind, ist die OBE der Akt des Einsatzes von Personal.",
      vibrationalTitle: "Der Vibrationszustand",
      vibrationalContent: "Das Startsignal der Trennung. Reite auf der Welle, anstatt sie zu fürchten.",
      protocols: [
        { name: "Protokoll 1: Das Ausrollen", description: "Rolle dein Bewusstsein mental um, ohne die Muskeln anzuspannen." },
        { name: "Protokoll 2: Das Herausheben", description: "Stelle dir deinen Energiekörper als Heliumballon vor und schwebe nach oben." },
        { name: "Protokoll 3: Teleportation", description: "Verschiebe den Fokus sofort an einen entfernten Ort." }
      ],
      closing: "Die Silberschnur ist deine unendliche, unzerstörbare Verbindung."
    },
    briefing: {
      title: "Geheimdienst-Briefing",
      sensations: "EMPFINDUNGEN",
      methodology: "METHODIK"
    }
  }
};

export const getLocalizedFocusConfigs = (lang: Language): StateConfig[] => {
  const isIt = lang === Language.IT;
  const isDe = lang === Language.DE;
  return [
    {
      id: FocusState.FOCUS_10,
      name: isIt ? 'Focus 10: Mente Sveglia / Corpo Addormentato' : isDe ? 'Focus 10: Geist wach / Körper schläft' : 'Focus 10: Mind Awake / Body Asleep',
      brainwaveType: 'THETA',
      description: isIt ? `Focus 10 è lo stato fondamentale di rilassamento fisico totale mentre la mente rimane completamente sveglia e vigile.
### L'ESPERIENZA SENSORIALE
• Rigidità Fisica: Il corpo sembra pesante, come fatto di pietra, mentre la mente rimane eccezionalmente chiara.
• Visioni Ipnagogiche: Sottili schemi di luce o forme geometriche possono apparire dietro le palpebre chiuse.
• Spostamenti Auditivi: I suoni esterni sembrano distanti o insignificanti.
• Sensazione di Fluttuazione: Un senso di distacco dal peso fisico degli arti.
### TUTORIAL: I PASSAGGI
1. SCATOLA DI CONVERSIONE ENERGETICA: Metti tutte le preoccupazioni fisiche e mondane nella scatola di contenimento. (COMPLETATO)
2. PALLONE DI ENERGIA RISONANTE (REBAL): Attiva la tua sfera protettiva ad alta frequenza per schermare la tua consapevolezza.
3. AFFERMAZIONE: Ripeti internamente "Io sono più del mio corpo fisico"
4. CORPO ADDORMENTATO: Rilascia sistematicamente la tensione da ogni gruppo muscolare partendo dalle dita dei piedi.` : isDe ? `Focus 10 ist der grundlegende Zustand totaler körperlicher Entspannung, während der Geist voll wach und wachsam bleibt.
### DIE SENSORISCHE ERFAHRUNG
• Körperliche Starrheit: Der Körper fühlt sich schwer an, als wäre er aus Stein, während der Geist außergewöhnlich klar bleibt.
• Hypnagoge Bilder: Subtile Lichtmuster oder geometrische Formen können hinter geschlossenen Augenlidern erscheinen.
• Akustische Verschiebungen: Außengeräusche erscheinen fern oder unbedeutend.
• Schwebegefühl: Ein Gefühl der Loslösung vom physischen Gewicht der Gliedmaßen.
### TUTORIAL: DIE SCHRITTE
1. ENERGIE-UMWANDLUNGS-BOX: Lege alle physischen und weltlichen Sorgen in die Eindämmungsbox. (ABGESCHLOSSEN)
2. RESONANZ-ENERGIE-BALLON (REBAL): Aktiviere deine hochfrequente Schutzsphäre, um dein Bewusstsein abzuschirmen.
3. AFFIRMATION: Wiederhole innerlich "Ich bin mehr als mein physischer Körper"
4. KÖRPER SCHLÄFT: Löse systematisch die Spannung aus jeder Muskelgruppe, beginnend bei den Zehen.` : `Focus 10 is the foundational state of total physical relaxation while the mind remains fully awake and alert.
### THE SENSORY EXPERIENCE
• Physical Rigidity: The body feels heavy, as if made of stone, while the mind remains exceptionally clear.
• Hypnagogic Visuals: Subtle patterns of light or geometric shapes may appear behind closed eyelids.
• Auditory Shifts: External sounds seem distant or insignificant.
• Floating Sensation: A feeling of detachment from the physical weight of the limbs.
### TUTORIAL: THE STEPS
1. ENERGY CONVERSION BOX: Place all physical and worldly concerns into the containment box. (COMPLETED)
2. RESONANT ENERGY BALLOON (REBAL): Activate your high-frequency protective sphere to shield your awareness.
3. AFFIRMATION: Repeat internally "I am more than my physical body"
4. BODY ASLEEP: Systematically release tension from every muscle group starting from the toes.`,
      baseFreq: 100,
      binauralFreq: 4,
      isLocked: false,
      color: '#3b82f6',
      durationSeconds: 1200, // 20 mins
      durationLabel: isIt ? '20 MIN' : isDe ? '20 MIN' : '20 MINS'
    },
    {
      id: FocusState.FOCUS_12,
      name: isIt ? 'Focus 12: Consapevolezza Espansa' : isDe ? 'Focus 12: Erweitertes Bewusstsein' : 'Focus 12: Expanded Awareness',
      brainwaveType: 'ALPHA',
      description: isIt ? `La coscienza si espande oltre i limiti del corpo fisico.
### L'ESPERIENZA SENSORIALE
• Espansione Spaziale: La stanza sembra vasta, o ti senti come se ti stessi espandendo nel cielo.
• Visione Non Fisica: Percezione di "scene" o luoghi che non sono fisicamente presenti.
• Impulso Vibrazionale: Una sensazione elettrica dolce e ritmica che scorre attraverso il sistema nervoso.
• Echi Distanti: Sentire pensieri o suoni provenienti da oltre la tua posizione temporale immediata.
### TUTORIAL: I PASSAGGI
1. STABILITÀ DI BASE: Raggiungi il Focus 10 e assicurati che il corpo sia completamente addormentato.
2. MANUTENZIONE REBAL: Verifica l'integrità della tua sfera protettiva prima dell'espansione.
3. LO SPOSTAMENTO OLOGRAFICO: Immagina la tua coscienza come un punto di luce che si espande in una sfera.
4. OSSERVAZIONE: Rimani un osservatore silenzioso di qualsiasi immagine o dato che entra nel tuo campo.` : isDe ? `Das Bewusstsein dehnt sich über die Grenzen des physischen Körpers hinaus aus.
### DIE SENSORISCHE ERFAHRUNG
• Räumliche Ausdehnung: Der Raum fühlt sich weit an, oder du hast das Gefühl, dich in den Himmel auszudehnen.
• Nicht-physische Sicht: Wahrnehmung von "Szenen" oder Orten, die physisch nicht vorhanden sind.
• Vibrationsimpuls: Ein sanftes, rhythmisches elektrisches Gefühl, das durch das Nervensystem fließt.
• Fernes Echo: Hören von Gedanken oder Geräuschen von jenseits deines unmittelbaren zeitlichen Standorts.
### TUTORIAL: DIE SCHRITTE
1. BASISSTABILITÄT: Erreiche Fokus 10 und stelle sicher, dass der Körper vollständig schläft.
2. REBAL-WARTUNG: Überprüfe die Integrität deiner Schutzsphäre vor der Ausdehnung.
3. DIE HOLOGRAPHISCHE VERSCHIEBUNG: Stelle dir dein Bewusstsein als einen Lichtpunkt vor, der sich zu einer Kugel ausdehnt.
4. BEOBACHTUNG: Bleibe ein stiller Beobachter aller Bilder oder Daten, die in dein Feld eintreten.` : `Consciousness expands beyond the limits of the physical body.
### THE SENSORY EXPERIENCE
• Spatial Expansion: The room feels vast, or you feel as if you are expanding into the sky.
• Non-Physical Vision: Perception of "scenes" or places that are not physically present.
• Vibrational Pulse: A gentle, rhythmic electrical sensation flowing through the nervous system.
• Distant Echoes: Hearing thoughts or sounds from beyond your immediate temporal location.
### TUTORIAL: THE STEPS
1. BASELINE STABILITY: Reach Focus 10 and ensure the body is fully asleep.
2. REBAL MAINTENANCE: Verify the integrity of your protective sphere before expansion.
3. THE HOLOGRAPHIC SHIFT: Imagine your consciousness as a point of light expanding into a sphere.
4. OBSERVATION: Remain a silent observer of any imagery or data that enters your field.`,
      baseFreq: 100,
      binauralFreq: 10,
      isLocked: false,
      color: '#8b5cf6',
      durationSeconds: 900, // 15 mins
      durationLabel: isIt ? '15 MIN' : isDe ? '15 MIN' : '15 MINS'
    },
    {
      id: FocusState.FOCUS_15,
      name: isIt ? 'Focus 15: Senza Tempo (L\'Adesso)' : isDe ? 'Focus 15: Zeitlosigkeit (Das Jetzt)' : 'Focus 15: No Time (The Now)',
      brainwaveType: 'DELTA',
      description: isIt ? `La dimensione del "Non-Tempo". Puro essere oltre i vincoli della durata biologica.
### L'ESPERIENZA SENSORIALE
• Silenzio Eterno: Un profondo senso di quiete dove il tempo cessa di esercitare pressione.
• Vuoto Oscuro: Esperienza di un "Oscurità 3D" che sembra infinitamente profonda e pacifica.
• Pura Intenzione: Manifestare i pensieri nella realtà avviene istantaneamente senza ritardo temporale.
• Unità: Un assottigliamento del velo tra il sé e l'assoluto.
### TUTORIAL: I PASSAGGI
1. ENTRATA NEL VUOTO: Dal Focus 12, spostati mentalmente all'indietro nell'oscurità dietro i tuoi occhi.
2. RILASCIARE I MOMENTI: Lascia andare il passato e il futuro. Esiste solo l' "Adesso".
3. IL PUNTO FERMO: Trova il centro della sfera di espansione dove il movimento si ferma.
4. MANIFESTAZIONE: Formula una singola intenzione chiara e rilasciala nel vuoto.` : isDe ? `Die Dimension der "Zeitlosigkeit". Reines Sein jenseits der Zwänge biologischer Dauer.
### DIE SENSORISCHE ERFAHRUNG
• Ewige Stille: Ein tiefes Gefühl der Ruhe, in dem die Zeit aufhört, Druck auszuüben.
• Dunkle Leere: Erfahrung einer "3D-Schwärze", die sich unendlich tief und friedlich anfühlt.
• Reine Intention: Die Manifestation von Gedanken in die Realität erfolgt augenblicklich ohne zeitliche Verzögerung.
• Einheit: Ein Dünnerwerden des Schleiers zwischen dem Selbst und dem Absoluten.
### DIE SENSORISCHE ERFAHRUNG
1. EINTRITT IN DIE LEERE: Bewege dich von Fokus 12 aus mental rückwärts in die Dunkelheit hinter deinen Augen.
2. MOMENTE LOSLASSEN: Lass die Vergangenheit und die Zukunft los. Nur das "Jetzt" existiert.
3. DER RUHEPUNKT: Finde das Zentrum der Expansionssphäre, wo die Bewegung aufhört.
4. MANIFESTATION: Formuliere eine einzige klare Absicht und entlasse sie in die Leere.` : `The dimension of "No-Time." Pure being beyond the constraints of biological duration.
### THE SENSORY EXPERIENCE
• Eternal Silence: A profound sense of stillness where time ceases to exert pressure.
• Dark Void: Experience of a "3D Blackness" that feels infinitely deep and peaceful.
• Pure Intention: Manifesting thoughts into reality occurs instantly without temporal delay.
• Unity: A thinning of the veil between the self and the absolute.
### THE SENSORY EXPERIENCE
1. THE VOID ENTRY: From Focus 12, mentally move backward into the darkness behind your eyes.
2. RELEASING MOMENTS: Let go of the past and the future. Only the "Now" exists.
3. THE STILL POINT: Find the center of the sphere of expansion where movement stops.
4. MANIFESTATION: Formulate a single clear intention and release it into the void.`,
      baseFreq: 60,
      binauralFreq: 1.5, 
      isLocked: false,
      color: '#ec4899',
      durationSeconds: 600, // 10 mins
      durationLabel: isIt ? '10 MIN' : isDe ? '10 MIN' : '10 MINS'
    },
    {
      id: FocusState.FOCUS_21,
      name: isIt ? 'Focus 21: Il Ponte' : isDe ? 'Focus 21: Die Brücke' : 'Focus 21: The Bridge',
      brainwaveType: 'DEEP DELTA',
      description: isIt ? `Il confine dell'universo olografico. La soglia finale del processo Gateway.
### L'ESPERIENZA SENSORIALE
• Contatto Interdimensionale: Percezioni di altre intelligenze o sistemi di guida.
• La Luce Bianca: Uno spostamento dall'oscurità del Focus 15 in una radiosità brillante e non accecante.
• Integrazione Totale: La sensazione di essere ovunque e in nessun luogo simultaneamente.
• Conoscenza Infinita: Accesso al flusso di informazioni "Akashico".
### TUTORIAL: I PASSAGGI
1. ATTRAVERSARE LA SOGLIA: Muoviti attraverso il centro del vuoto del Focus 15.
2. ARMONIA VIBRAZIONALE: Allinea la tua frequenza interna con lo spostamento delta di 0.5Hz.
3. FORMAZIONE DEL PONTE: Visualizza un sentiero di luce che conduce oltre l'universo fisico.
4. IL PROTOCOLLO DI RITORNO: Mantieni sempre l'intenzione di tornare al Focus 1 al completamento.` : isDe ? `Der Rand des holographischen Universums. Die letzte Schwelle des Gateway-Prozesses.
### DIE SENSORISCHE ERFAHRUNG
• Interdimensionaler Kontakt: Wahrnehmungen anderer Intelligenzen oder Leitsysteme.
• Das weiße Licht: Ein Wechsel von der Schwärze von Fokus 15 in ein brillantes, nicht blendendes Strahlen.
• Totale Integration: Das Gefühl, gleichzeitig überall und nirgendwo zu sein.
• Unendliches Wissen: Zugang zum "Akasha"-Informationsstrom.
### TUTORIAL: DIE SCHRITTE
1. ÜBERSCHREITEN DER SCHWELLE: Bewege dich durch das Zentrum der Fokus-15-Leere.
2. VIBRATIONS-HARMONIE: Richte deine interne Frequenz auf die 0,5-Hz-Delta-Verschiebung aus.
3. DIE BRÜCKENBILDUNG: Visualisiere einen Lichtpfad, der über das physische Universum hinausführt.
4. DAS RÜCKKEHRPROTOKOLL: Behalte immer die Absicht bei, nach Abschluss zu Fokus 1 zurückzukehren.` : `The edge of the holographic universe. The final threshold of the Gateway process.
### THE SENSORY EXPERIENCE
• Interdimensional Contact: Perceptions of other intelligence or guidance systems.
• The White Light: A shift from the blackness of Focus 15 into a brilliant, non-blinding radiance.
• Total Integration: The feeling of being everywhere and nowhere simultaneously.
• Infinite Knowledge: Access to the "Akashic" stream of information.
### THE SENSORY EXPERIENCE
1. CROSSING THE THRESHOLD: Move through the center of the Focus 15 void.
2. VIBRATIONAL HARMONY: Align your internal frequency with the 0.5Hz delta shift.
3. THE BRIDGE FORMATION: Visualize a path of light leading beyond the physical universe.
4. THE RETURN PROTOCOL: Always maintain the intention to return to Focus 1 upon completion.`,
      baseFreq: 60,
      binauralFreq: 0.5,
      resonance: 800,
      isLocked: false,
      color: '#f59e0b',
      durationSeconds: 900, // 15 mins
      durationLabel: isIt ? '15 MIN' : isDe ? '15 MIN' : '15 MINS'
    }
  ];
};

export const FOCUS_CONFIGS: StateConfig[] = getLocalizedFocusConfigs(Language.EN);

export const APP_MODES = {
  LANGUAGE: 'language',
  LANDING: 'landing',
  APP: 'app'
};
